var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgDisableChat = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50242 1.58545L15.7017 14.7854L14.7584 15.7281L12.3531 13.3228L4.93375 13.3234L1.96375 15.6568V3.32345C1.96375 3.21012 1.99175 3.10412 2.04108 3.01078L1.55908 2.52878L2.50242 1.58545ZM3.29642 4.26545L3.29708 12.9134L4.47242 11.9901H11.0197L3.29708 4.26478L3.29642 4.26545ZM14.6304 2.65678C14.8072 2.65678 14.9768 2.72702 15.1018 2.85204C15.2268 2.97707 15.2971 3.14664 15.2971 3.32345V12.5134L13.9637 11.1801V3.99012L6.77242 3.98945L5.43975 2.65678H14.6304Z",
    fill: "white"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgDisableChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/disable-chat.4160e07a8d78e6aba515b64242886bf6.svg";